import { ENV } from "../Utils"; // Asegúrate de que la ruta a Utils es correcta
import { apiFetch } from "../Utils/apiFetch";

export class VirtualScenes {
  baseApi = ENV.BASE_API;

  // Método para crear una escena virtual
  async createModule_00(accessToken, formValue) {
    try {
      const url = `${this.baseApi}/module_00`; // Endpoint de creación de escena

      const params = {
        method: "POST", // Método PATCH para crear
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(formValue),
      };

      const response = await fetch(url, params);

      if (!response.ok) {
        throw new Error("Error en la creación de la escena");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error al crear la escena virtual:", error);
      throw error;
    }
  }
  // NUEVO: devuelve la escena completa con populate de bannertop.url
  async getVirtualSceneById(accessToken, sceneId) {
    try {
      const url = `${this.baseApi}/virtualscene/${sceneId}`;
      const params = {
        method: "GET",
        headers: { Authorization: `Bearer ${accessToken}` },
      };
      const response = await apiFetch(url, params);
      const result = await response.json();
      if (!response.ok) throw result;
      return result; // objeto scene completo
    } catch (error) {
      console.error("Error al obtener la escena:", error);
      throw error;
    }
  }
  // Método para obtener todas las escenas virtuales
  async getVirtualScenesMini({ page, limit }, accessToken) {
    try {
      const url = `${this.baseApi}/virtualscenes/mini?page=${page}&limit=${limit}`;

      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await apiFetch(url, params);

      if (!response.ok) {
        throw new Error("Error al obtener las escenas");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error al obtener las escenas:", error);
      throw error;
    }
  }
  async getVirtualScenesMiniCreator({ page, limit }, accessToken) {
    try {
      const url = `${this.baseApi}/virtualscenes/mini-creator?page=${page}&limit=${limit}`;

      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await apiFetch(url, params);

      if (!response.ok) {
        throw new Error("Error al obtener las escenas");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error al obtener las escenas:", error);
      throw error;
    }
  }
  async getVirtualScenesMiniFree({ page, limit }, accessToken) {
    try {
      const url = `${this.baseApi}/virtualscenes/minifree?page=${page}&limit=${limit}`;

      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await apiFetch(url, params);

      if (!response.ok) {
        throw new Error("Error al obtener las escenas");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error al obtener las escenas:", error);
      throw error;
    }
  }
  async getVirtualScenesModeule(refId, accessToken, modulePath) {
    try {
      const url = `${this.baseApi}/virtualscene/${refId}/${modulePath}`;

      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await apiFetch(url, params);

      if (!response.ok) {
        throw new Error("Error al obtener las escenas");
      }

      const result = await response.json();
      //console.log("result", result);
      return result;
    } catch (error) {
      console.error("Error al obtener las escenas:", error);
      throw error;
    }
  }
  async getFileScene(id) {
    try {
      const url = `${this.baseApi}/filescene/${id}`;

      const params = {
        method: "GET",
      };

      const response = await fetch(url, params);

      if (!response.ok) {
        throw new Error("Error al obtener las escenas");
      }

      const result = await response.json();
      //console.log("result", result);
      return result;
    } catch (error) {
      console.error("Error al obtener las escenas:", error);
      throw error;
    }
  }
  async getRepoScene(id, accessToken) {
    try {
      const url = `${this.baseApi}/reposcene/${id}`;

      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);

      if (!response.ok) {
        throw new Error("Error al obtener las escenas");
      }

      const result = await response.json();
      console.log("result", result);
      return result;
    } catch (error) {
      console.error("Error al obtener las escenas:", error);
      throw error;
    }
  }
  // Método para actualizar una escena virtual
  async createModuleAdd(modulePath, accessToken, _id, values) {
    console.log("Creando módulo...", modulePath);
    //console.log("accessToken", accessToken);
    //console.log("_id", _id);
    //console.log("values", values);
    try {
      const url = `${this.baseApi}/${modulePath}/${_id}`; // URL corregida

      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(values),
      };

      const response = await fetch(url, params);

      if (!response.ok) {
        throw new Error("Error en la actualización de la escena");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error al actualizar la escena virtual:", error);
      throw error;
    }
  }

  // Método para eliminar una escena virtual
  async deleteVirtualScene(accessToken, _id) {
    console.log("Eliminando escena...", _id);
    try {
      const url = `${this.baseApi}/virtualscene/${_id}`;

      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);

      if (!response.ok) {
        throw new Error("Error al eliminar la escena");
      }

      return response.json();
    } catch (error) {
      console.error("Error al eliminar la escena virtual:", error);
      throw error;
    }
  }

  // Método para subir un archivo de imagen
  async uploadImageFile(accessToken, formValue) {
    try {
      console.log("Subiendo imagen...", formValue);

      const formData = new FormData();
      formData.append("idScene", formValue.idScene);
      formData.append("title", formValue.title);
      formData.append("description", formValue.description);
      formData.append("isPublic", formValue.isPublic);
      formData.append("file", formValue.file);

      const url = `${this.baseApi}/virtualscene/uploadimage`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`, // No añadas Content-Type, fetch lo gestionará automáticamente
        },
        body: formData,
      };

      //console.log("params", params);
      const response = await fetch(url, params);
      //console.log("respuesta", response);

      if (!response.ok) {
        const errorResult = await response.json();
        throw errorResult;
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error subiendo imagen:", error);
      throw error;
    }
  }

  // Método para subir un archivo de repositorio
  async uploadRepoFile(accessToken, formValue) {
    try {
      //console.log("Subiendo repositorio...", formValue);

      const formData = new FormData();
      formData.append("idScene", formValue.idScene);
      formData.append("title", formValue.title);
      formData.append("description", formValue.description);
      formData.append("isPublic", false); // Repositorio es privado
      formData.append("file", formValue.file);

      const url = `${this.baseApi}/virtualscene/uploadrepo`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      //console.log("params", params);
      const response = await fetch(url, params);
      //console.log("respuesta", response);

      if (!response.ok) {
        const errorResult = await response.json();
        throw errorResult;
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error subiendo repositorio:", error);
      throw error;
    }
  }

  // Método para eliminar una imagen o repositorio
  async deleteImageRepo(accessToken, _id) {
    try {
      const url = `${this.baseApi}/virtualscene/image/${_id}`;

      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);

      if (!response.ok) {
        throw new Error("Error al eliminar la imagen/repositorio");
      }

      return response.json();
    } catch (error) {
      console.error("Error al eliminar la imagen/repositorio:", error);
      throw error;
    }
  }
  async getPrivatePdf(accessToken, fileId) {
    try {
      const url = `${this.baseApi}/privatepdf/${fileId}`;
      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);

      if (!response.ok) {
        throw new Error("Error al obtener la URL firmada para el PDF privado");
      }

      // El backend retorna un objeto { url: "..." }
      const result = await response.json();
      return result; // { url: "https://..." }
    } catch (error) {
      console.error("Error al obtener la URL firmada:", error);
      throw error;
    }
  }
}
